module.exports = __webpack_public_path__ + "img/JTF-min.22e8b49b.png";